import { BatchResult } from "../../hooks/useBatchProcessing"

interface ResultsSummaryProps {
    results: BatchResult[]
    processingType: "last_occurrence" | "all_occurrences"
}

export const ResultsSummary = ({
    results,
    processingType
}: ResultsSummaryProps) => {
    if (results.length === 0) return null

    const successCount = results.filter((r) => r.success).length
    const errorCount = results.filter((r) => !r.success).length
    const totalOccurrences = results.reduce(
        (acc, r) =>
            r.success ? acc + (r.data?.ocorrencias.length || 0) : acc + 1,
        0
    )

    return (
        <div className="bg-white rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
                Resumo dos Resultados
            </h3>
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm text-blue-800">
                    <strong>Tipo de processamento:</strong>{" "}
                    {processingType === "last_occurrence"
                        ? "Última Ocorrência"
                        : "Todas as Ocorrências"}
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <div className="text-2xl font-bold text-green-600">
                        {successCount}
                    </div>
                    <div className="text-sm text-green-700">Sucessos</div>
                </div>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="text-2xl font-bold text-red-600">
                        {errorCount}
                    </div>
                    <div className="text-sm text-red-700">Erros</div>
                </div>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="text-2xl font-bold text-blue-600">
                        {results.length}
                    </div>
                    <div className="text-sm text-blue-700">
                        {processingType === "last_occurrence"
                            ? "Consultas"
                            : `Linhas no CSV: ${totalOccurrences}`}
                    </div>
                </div>
            </div>
        </div>
    )
}
